import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { getInputImageAsset } from 'Pods/ThreeDStudio/Shared/Utils/getInputImageAsset'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { deriveMaterialForTripo3D } from './deriveMaterialForTripo3D'
import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D image-to-3d-default run.
 * Reads the input image from inputAssets, infers modelFormatOutput from the
 * generated 3d_model URL when not explicitly set, derives material from
 * enablePbr/geometryOnly, and opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dImageTo3dDefaultData = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    private: isPrivate,
    useCase,
  } = openedModel
  const {
    polyCount: targetPolycount,
    topology: polygonType,
    materialMode,
    generateType,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterialForTripo3D(materialMode)
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getInputImageAsset(inputAssets)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.TRIPO3D
  const generationAction = ACTION.IMAGE_TO_3D
  const isSmartLowPoly = generateType === 'LowPoly'

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  const modelSettings = isSmartLowPoly ?
  {
    isSmartLowPoly,
    inputImage,
    inputImageUrl,
    isPrivate,
    selectedUseCase: useCase,
  } : {
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    inputImage,
    inputImageUrl,
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    ui,
    generation,
    viewer,
  }
}
